import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	pageTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	pageTitle: {
		id: 'directories.dashboards-v2.page.page-title',
		defaultMessage: 'Dashboards',
		description: 'Dashboards directory page title',
	},
});
export default messages;
